import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { MultiCheckboxGroup } from '../CheckBox/CheckBox'

const SelectOptionsFamilias = ({ className, name, id, optDefault, onChange }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + 'Productos/Familias')
      .then(function (response) {
        const res = response.data
        setOptions(res.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  }, [])

  return (
    <select name={name} id={id}
      onChange={onChange}
      className={className}
      defaultValue={''}
    >
      <option
        key={1}
        value=''
        disabled
      >
        {optDefault}
      </option>
      {options.map((option) => (
        <option
          key={option.id}
          value={option.id}
        >
          {option.name}
        </option>
      ))}
    </select>
  )
}

const SelectOptionsDistribuidores = ({ className, name, id, optDefault, onChange }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + 'Productos/Distribuidores')
      .then(function (response) {
        const res = response.data
        setOptions(res.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  }, [])

  return (
    <select name={name} id={id}
      onChange={onChange}
      className={className}
      defaultValue={''}
    >
      <option
        key={1}
        value=''
        disabled
      >
        {optDefault}
      </option>
      {options.map((option) => (
        <option
          key={option.id}
          value={option.id + '-' + option.nombre}
        >
          {option.nombre}
        </option>
      ))}
    </select>
  )
}

const OptionsTipoCliente = ({ handleChange, selectedOption }) => {
  const [tiposCliente, setTiposCliente] = useState([])
  const [ctLoading, setCtLoading] = useState(false)
  const [ctError, setCtError] = useState('')

  useEffect(() => {
    setCtLoading(true)
    setCtError('')
    axios
      .get(process.env.REACT_APP_BACKEND_URL + 'customer-type')
      .then(function (r) {
        const res = r.data
        setTiposCliente(res.data)
      })
      .catch(function (err) {
        const status = err && err.response && err.response.status
        const msg = status
          ? 'HTTP ' + status
          : err && err.message
            ? err.message
            : 'No se pudieron cargar los tipos'
        setCtError(msg)
        setTiposCliente([])
      })
      .finally(() => {
        setCtLoading(false)
      })
  }, [])

  return (
    <div className='box-list' aria-busy={ctLoading}>
      {ctLoading && <p style={{ margin: '6px 0' }}>Cargando tipos de cliente…</p>}
      {ctError && (
        <p style={{ color: '#b00020', margin: '6px 0' }}>
          No se pudieron cargar los tipos ({ctError}). Puedes escribir en “Otros”.
        </p>
      )}
      {tiposCliente.map((tc) => (
        <label key={tc.id}>
          <input
            type='radio'
            name='clientes_objetivo'
            value={tc.name}
            disabled={ctLoading}
            checked={selectedOption === tc.name}
            onChange={handleChange}
          />
          {tc.name}
        </label>
      ))}
    </div>
  )
}

const OptionsFamilias = ({ handleChange, handleInput, valueproductos, valueotros }) => {
  const [familias, setFamilias] = useState([])
  const [ctLoading, setCtLoading] = useState(false)
  const [ctError, setCtError] = useState('')
  useEffect(() => {
    setCtLoading(true)
    axios
      .get(process.env.REACT_APP_BACKEND_URL + 'Productos/Familias')
      .then((r) => setFamilias(r.data.data))
      .catch((err) => {
        const status = err && err.response && err.response.status
        const msg = status
          ? 'HTTP ' + status
          : err && err.message
            ? err.message
            : 'No se pudieron cargar los tipos'
        setCtError(msg)
        setFamilias([])
      })
      .finally(() => {
        setCtLoading(false)
      })
  }, [])

  return <>
    {ctLoading && <p style={{ margin: '6px 0' }}>Cargando familias…</p>}
    {ctError && (
      <p style={{ color: '#b00020', margin: '6px 0' }}>
        No se pudieron cargar las familias ({ctError}). Puedes escribir en “Otros”.
      </p>
    )}
    <MultiCheckboxGroup
      name={'productos_vendidos'}
      options={familias}
      selectedValues={valueproductos}
      onChange={handleChange}
      className='input-field-distribuidor' />
    <div style={{ marginTop: 8 }}>
      <input
        type='text'
        maxLength={50}
        placeholder='Otros (especifica)'
        name='otrosProductos'
        onChange={handleChange}
        value={valueotros}
        onInput={handleInput}
        className='input-field-distribuidor'
      />
    </div>
  </>
}

SelectOptionsDistribuidores.propTypes = {
  className: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  optDefault: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

SelectOptionsFamilias.propTypes = {
  className: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  optDefault: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

OptionsTipoCliente.propTypes = {
  handleChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.string.isRequired
}

OptionsFamilias.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleInput: PropTypes.func.isRequired,
  valueproductos: PropTypes.array.isRequired,
  valueotros: PropTypes.string.isRequired
}

export { SelectOptionsDistribuidores, SelectOptionsFamilias, OptionsTipoCliente, OptionsFamilias }
